var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@irati/utils/lang";
import { Nav, Ul, MenuListItem, MenuItemLink } from "./styled";
var SideNavigation = function (_a, _b) {
    var links = _a.links;
    var appPath = _b.appPath;
    return (React.createElement(Nav, null,
        React.createElement(Ul, null, links
            .filter(function (t) { return !!t; })
            .map(function (link) {
            var to = link.to, label = link.label, isCategory = link.isCategory, onClick = link.onClick, app = link.app, color = link.color, id = link.id, props = __rest(link, ["to", "label", "isCategory", "onClick", "app", "color", "id"]);
            var pathname = window.location.pathname;
            return (link && (React.createElement(MenuListItem, { isCategory: !!isCategory, key: label },
                React.createElement(MenuItemLink, __assign({}, props, { id: id, plain: true, isCurrent: pathname === "" + appPath + to || pathname.includes("" + appPath + to), isCategory: isCategory, onClick: onClick, color: color, app: app, to: to }),
                    React.createElement(FormattedMessage, { id: label })))));
        }))));
};
SideNavigation.contextTypes = {
    appPath: PropTypes.string.isRequired
};
export default SideNavigation;
